// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "PhDUploadForm",
  formField: {
    statementReportGuideline: {
      name: "statementReportGuideline",
      label: "Have you read entire statement in report guideline? *",
      requiredErrorMsg: "Report guideline is required"
    },
    /////////////////Page1Form 3Year/////////////////////////////
    yourProgramType: {
      name: "yourProgramType",
      label: "Your Program Type *",
      requiredErrorMsg: "Program Type is required"
    },
    sendingScholarshipReport: {
      name: "sendingScholarshipReport",
      label: "Sending scholarship report for *",
      requiredErrorMsg: "Sending scholarship report is required"
    },
    semester: {
      name: "semester",
      label: "Semester",
      requiredErrorMsg: "Semester is required"
    },
    /////////////////Page1Form 3Year/////////////////////////////

    /////////////////Page2Form 2A/////////////////////////////
    receivingScholarship: {
      name: "receivingScholarship",
      label: "Year of receiving scholarship",
      requiredErrorMsg: "Receiving scholarship is required"
    },
    reportNo: {
      name: "reportNo",
      label: "Report No.",
      requiredErrorMsg: "Report No is required"
    },
    previousSemester: {
      name: "previousSemester",
      label: "For previous semester",
      requiredErrorMsg: "Previous semester is required"
    },
    inputList: {
      name: "inputList",
      subMenu: [
        {
          subjectCourseNo: {
            name: "subjectCourseNo",
            label: "Subject/Course No. *",
            requiredErrorMsg: "Subject/Course No is required"
          },
          courseTitle: {
            name: "courseTitle",
            label: "Course Title *",
            requiredErrorMsg: "Course Title is required"
          },
          credit: {
            name: "credit",
            label: "Credit *",
            requiredErrorMsg: "Credit is required"
          },
          grade: {
            name: "grade",
            label: "Grade *",
            requiredErrorMsg: "Grade is required"
          }
        }
      ]
    },
    receivedGradeReportGpa: {
      name: "receivedGradeReportGpa",
      label:
        "If you have received grade report as GPA &lt; 3.00 or X, I, or U. Please explain your reasons and problem solution plan:",
      requiredErrorMsg: "Is required"
    },
    thesisCreditsProgram: {
      name: "thesisCreditsProgram",
      label: "Total Thesis credits as program required:",
      requiredErrorMsg: "Total Thesis credits is required"
    },
    currentTotalThesisCredits: {
      name: "currentTotalThesisCredits",
      label: "Current total thesis credits earned:",
      requiredErrorMsg: "Current total thesis credits is required"
    },
    remainingThesisCreditsProgram: {
      name: "remainingThesisCreditsProgram",
      label: "Remaining Thesis credits as program requirement:",
      requiredErrorMsg: "Remaining Thesis credits is required"
    },
    gpa: {
      name: "gpa",
      label: "GPA*",
      requiredErrorMsg: "GPA is required"
    },
    gpax: {
      name: "gpax",
      label: "Cumulative GPA (GPAX)*",
      requiredErrorMsg: "GPAX is required"
    },
    currentTotalCredits: {
      name: "currentTotalCredits",
      label: "Current total credits earned",
      requiredErrorMsg: "Current total credits is required"
    },
    remainingCreditsProgram: {
      name: "remainingCreditsProgram",
      label: "Remaining credits as program requirement",
      requiredErrorMsg: "Remaining credits is required"
    },
    researchTitleSelect: {
      name: "researchTitleSelect",
      label: "Your Research Field/Category *",
      requiredErrorMsg: "Research Fieldis required"
    },
    mainResearchArea: {
      name: "mainResearchArea",
      label: "Your Main Research Area:",
      requiredErrorMsg: "Main Research Area is required"
    },
    researchTitle: {
      name: "researchTitle",
      label: "Your Research Title (In English)",
      requiredErrorMsg: "Research Title is required"
    },
    /////////////////Page2Form 2A/////////////////////////////

    /////////////////Page3Form 2B/////////////////////////////
    startWritingResearchProposal: {
      name: "startWritingResearchProposal",
      label: "Did you start writing your research proposal?",
      requiredErrorMsg: "Research proposal is required"
    },
    uploadCurrentResearchProposal: {
      name: "uploadCurrentResearchProposal",
      label: "Please upload your current research proposal",
      requiredErrorMsg: "Research proposal file is required",
      file: {}
    },
    qualifyingExamResult: {
      name: "qualifyingExamResult",
      label: "Qualifying Exam Result",
      requiredErrorMsg: "Qualifying exam result is required"
    },
    whenQualifyingExamination: {
      name: "whenQualifyingExamination",
      label: "When do you pass your qualifying examination",
      requiredErrorMsg: "Qualifying examination is required"
    },
    proposalExaminationResult: {
      name: "proposalExaminationResult",
      label: "Proposal Examination Result",
      requiredErrorMsg: "Proposal examination result is required"
    },
    whenProposalExamination: {
      name: "whenProposalExamination",
      label: "When do you pass your proposal examination",
      requiredErrorMsg: "Proposal examination is required"
    },
    presentProgressResearchProject: {
      name: "presentProgressResearchProject",
      label: "Please select your present progress of the research project *",
      requiredErrorMsg: "Research project is required"
    },
    subjectAreaPublished: {
      name: "subjectAreaPublished",
      label:
        "List of Journal and Subject Area which you expect to be published; (for example: Journal: Energies / Subject Area: Electrical and Electronic Engineering) *",
      requiredErrorMsg: "Subject Area is required"
    },
    manuscriptPublication: {
      name: "manuscriptPublication",
      label: "Please upload your manuscript/publication",
      requiredErrorMsg: "manuscript/publication is required",
      file: {}
    },
    manuscriptId: {
      name: "manuscriptId",
      label: "Your Manuscript ID",
      requiredErrorMsg: "Manuscript id is required"
    },
    journalRanking: {
      name: "journalRanking",
      label: "Journal ranking",
      requiredErrorMsg: "Journal ranking is required"
    },
    conductingResearchAbroad6Months: {
      name: "conductingResearchAbroad6Months",
      label:
        "Do you have a future plan for conducting research abroad in next 6 months?",
      requiredErrorMsg: "conducting research abroad is required"
    },
    answerPlaning: {
      name: "answerPlaning",
      label: "If your answer is YES, when will the planing be?",
      requiredErrorMsg: "Planing abroad is required"
    },
    answerCountryPlan: {
      name: "answerCountryPlan",
      label: "If your answer is YES, which country do you plan to go?",
      requiredErrorMsg: "Country do you plan is required"
    },
    highPerformanceProfessor: {
      name: "highPerformanceProfessor",
      label:
        "Do you have an international collaborator for research collaboration from Top 100 University/ subject ranking or Top institute or high performance professor?",
      requiredErrorMsg: "High performance professor is required"
    },
    professorCollaboratorName: {
      name: "professorCollaboratorName",
      label: "International Professor/Collaborator Name",
      requiredErrorMsg: "Professor/Collaborator Name is required"
    },
    instituteProfessorCollaborator: {
      name: "instituteProfessorCollaborator",
      label: "University or Institute of Professor/Collaborator",
      requiredErrorMsg: "Institute of Professor/Collaborator is required"
    },
    /////////////////Page3Form 2B/////////////////////////////

    /////////////////Page2Form 2C/////////////////////////////
    yourResearchField: {
      name: "yourResearchField",
      label: "Your Research Field: *",
      requiredErrorMsg: "Research Field is required"
    },
    presentProgressResearchProject2c: {
      name: "presentProgressResearchProject2c",
      label: "Please select your present progress of the research project *",
      requiredErrorMsg: "Research project is required"
    },
    articleTitle: {
      name: "articleTitle",
      label: "Article Title *",
      requiredErrorMsg: "Article Title is required"
    },
    manuscriptId2c: {
      name: "manuscriptId2c",
      label: "Your Manuscript ID",
      requiredErrorMsg: "Manuscript ID is required"
    },
    typeManuscript: {
      name: "typeManuscript",
      label: "Type of Manuscript",
      requiredErrorMsg: "Type of Manuscript is required"
    },
    journal: {
      name: "journal",
      label: "Journal",
      requiredErrorMsg: "Journal is required"
    },
    subjectAreaCategory: {
      name: "subjectAreaCategory",
      label: "Subject area and category",
      requiredErrorMsg: "Subject area and category is required"
    },
    journalRanking2c: {
      name: "journalRanking2c",
      label: "Journal ranking:",
      requiredErrorMsg: "Journal ranking is required"
    },
    authors: {
      name: "authors",
      label: "Authors",
      requiredErrorMsg: "Authors is required"
    },
    uploadResearchPublication: {
      name: "uploadResearchPublication",
      label: "Please upload your research publication *",
      requiredErrorMsg: "Research publication is required",
      file: {}
    },
    receivedDate: {
      name: "receivedDate",
      label: "Received date",
      requiredErrorMsg: "Received date is required"
    },
    revisedDate: {
      name: "revisedDate",
      label: "Revised date",
      requiredErrorMsg: "Revised date is required"
    },
    acceptedDate: {
      name: "acceptedDate",
      label: "Accepted date",
      requiredErrorMsg: "Accepted date is required"
    },
    publishedDate: {
      name: "publishedDate",
      label: "Published date",
      requiredErrorMsg: "Published date is required"
    }
    /////////////////Page2Form 2C/////////////////////////////
  }
};
